<div class="dashboard">
  <div [hidden]="isLoading">
    <div class="mb mat-elevation-z8">
    <table [dataSource]="proposals" class="mat-elevation-z8 dashboard__table" mat-table>
        <ng-container matColumnDef="id">
          <th *matHeaderCellDef mat-header-cell class="id-column"> ID</th>
          <td *matCellDef="let element" mat-cell> {{ element.id }} </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell> Kategoria</th>
          <td *matCellDef="let element" mat-cell> {{ element.poolPublicationType.name }} </td>
        </ng-container>
        <ng-container matColumnDef="options">
          <th *matHeaderCellDef mat-header-cell class="options-column"> Opcje</th>
          <td *matCellDef="let element" mat-cell>
            <button [routerLink]="'/publisher/proposal/edit-email/'+element.id" mat-raised-button>
              Zmień e-mail
            </button>

          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <ng-container *ngIf="proposals">
        <mat-card *ngIf="proposals.length === 0" [hidden]="isLoading">
          Brak wyników do wyświetlenia
        </mat-card>
      </ng-container>
    </div>
  </div>
  <div *ngIf="isLoading" class="loading">
    <mat-spinner></mat-spinner>
  </div>
</div>
